module.exports = __webpack_public_path__ + "static/exchange-rate-970d6e162bebf886d0614253effa74d5.png";